export default "/images/vendor/flag-icon-css/flags/1x1/cn.svg?4fde2ed612a6a2f9ff03069a579a3bac";